import {
	BusinessMembersTable,
	InviteMemberDialog,
	PendingInvitations,
} from "@nwga/features/businesses/ui";
import { useTRPC } from "@nwga/features/client";
import { Button } from "@nwga/ui/components/button";
import { Separator } from "@nwga/ui/components/separator";
import { Skeleton } from "@nwga/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { UserPlusIcon } from "lucide-react";
import * as React from "react";
import { PageHeader } from "../../../components/page-header.tsx";

/**
 * Who else can post for this business.
 *
 * Its own URL rather than a tab: an invitation email that says "ask your
 * administrator" is far more useful when there is a page to send them to.
 */
export const Route = createFileRoute("/dashboard/$businessSlug/team")({
	component: TeamPage,
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			context.trpc.businesses.bySlug.queryOptions({
				slug: params.businessSlug,
			}),
		),
});

function TeamPage() {
	const { businessSlug } = Route.useParams();
	const trpc = useTRPC();
	const [inviting, setInviting] = React.useState(false);

	const session = useQuery(trpc.session.queryOptions());
	const business = useQuery(
		trpc.businesses.bySlug.queryOptions({ slug: businessSlug }),
	);

	if (!business.isSuccess) return <Skeleton className="h-72 w-full" />;

	return (
		<div className="space-y-6">
			<PageHeader
				title="Team"
				description="Everyone here can write listings for this business. Administrators can also publish them and invite others."
				actions={
					<Button onClick={() => setInviting(true)}>
						<UserPlusIcon className="size-4" aria-hidden="true" />
						Invite someone
					</Button>
				}
			/>

			{session.data?.user != null && (
				<BusinessMembersTable
					businessId={business.data.id}
					currentUserId={session.data.user.id}
				/>
			)}

			<Separator />

			<PendingInvitations businessId={business.data.id} />

			<InviteMemberDialog
				businessId={business.data.id}
				open={inviting}
				onOpenChange={setInviting}
			/>
		</div>
	);
}
